/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSouscriptionCompanyQuery from '../graphql/queries/GetSouscriptionCompanyQuery.js';

const useGetSouscriptionCompanyQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSouscriptionCompanyQuery, args);

  return {
    error,
    loading,
    refetch,
    getSouscriptionCompany: R.omit(['__typename'], data?.getSouscriptionCompany_souscription_company || {})
  };
};

export default useGetSouscriptionCompanyQuery;
